import * as Sentry from "@sentry/react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { routes } from "./routes";
import { appRoutes } from "./app/appRoutes";

// Marketing routes are pre-rendered; the signed-in app under /app is not.
// Wrapped so Sentry names page loads and navigations by route.
const router = Sentry.wrapCreateBrowserRouterV6(createBrowserRouter)([
  ...routes,
  ...appRoutes,
]);

const Router = () => <RouterProvider router={router} />;

export default Router;
